import { CREDENTIAL_DEFAULT_REMINDERS as SHARED_DEFAULT_REMINDERS } from "@toolkit/mobile-shared";
import type { CredentialReminderSlot } from "../pages/MainAppPage/types";

export const CREDENTIAL_MAX_REMINDERS = 8;

export const CREDENTIAL_REMINDER_CHANNELS = [
  { value: "both", label: "Email and push" },
  { value: "email", label: "Email" },
  { value: "push", label: "Push" },
] as const;

export const CREDENTIAL_DEFAULT_REMINDERS: Array<
  Pick<CredentialReminderSlot, "daysBefore" | "channel">
> = SHARED_DEFAULT_REMINDERS;

export type ReminderDraft = {
  key: string;
  daysBefore: string;
  channel: "email" | "push" | "both";
};

export function initialReminderDrafts(
  reminders: CredentialReminderSlot[] | undefined,
  confirmed: boolean | undefined,
): ReminderDraft[] {
  if (reminders && reminders.length > 0) {
    return reminders.map((row, index) => ({
      key: row.id ?? `existing-${index}`,
      daysBefore: String(row.daysBefore),
      channel: row.channel,
    }));
  }
  if (confirmed) return [];
  return CREDENTIAL_DEFAULT_REMINDERS.map((row, index) => ({
    key: `default-${index}`,
    daysBefore: String(row.daysBefore),
    channel: row.channel,
  }));
}

export function addReminderDraft(
  rows: ReminderDraft[],
  key = `new-${rows.length + 1}`,
): ReminderDraft[] {
  if (rows.length >= CREDENTIAL_MAX_REMINDERS) return rows;
  return [...rows, { key, daysBefore: "1", channel: "both" }];
}

export function removeReminderDraft(
  rows: ReminderDraft[],
  key: string,
): ReminderDraft[] {
  return rows.filter((row) => row.key !== key);
}
